import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import settings from './settings'
import cargoTypes from './cargoTypes'
import directories from './directories'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: process.env.NODE_ENV !== 'production', // в production должно быть отключено https://vuex.vuejs.org/ru/guide/strict.html

  actions: {
    async prefetch ({ dispatch }) {
      // const promises = [
      dispatch('directories/init', null, { root: true })
      // ]
      // await Promise.all(promises)
    }
  },

  modules: {
    auth,
    settings,
    cargoTypes,
    directories
  }
})
